// Externalize those 2 functions for mocking conveniance in unit tests

export const serverSidePush = /* istanbul ignore next */ (url) => {
  window.location.href = url;
};

export const serverSideReplace = /* istanbul ignore next */ (url) => {
  window.location.replace(url);
};
